var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49692 1.00098C6.68724 1.00098 6.86106 1.10903 6.94529 1.2797L8.3719 4.17037L11.5616 4.63265C11.7501 4.65996 11.9067 4.79194 11.9655 4.97305C12.0243 5.15415 11.9751 5.35294 11.8387 5.48576L9.52721 7.73575L10.0722 10.9129C10.1044 11.1006 10.0272 11.2903 9.87313 11.4021C9.71903 11.514 9.51478 11.5286 9.34633 11.4398L6.50016 9.94001L3.6471 11.44C3.47864 11.5286 3.2745 11.5139 3.12053 11.402C2.96655 11.2901 2.88944 11.1005 2.92162 10.9129L3.46664 7.73575L1.15516 5.48576C1.01872 5.35294 0.969555 5.15415 1.02837 4.97305C1.08718 4.79194 1.24376 4.65996 1.43221 4.63265L4.62194 4.17037L6.04855 1.2797C6.13278 1.10903 6.3066 1.00098 6.49692 1.00098Z",
    fill: "#DBFF00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/starFilled.aff88fbf300b5c0244d53784b4825e9a.svg";
export { ForwardRef as ReactComponent };